import styled from 'styled-components';

import { Text } from '@electricjs/arc';

export const MultiLineEllipsisText = styled(Text)<{ $maxLines: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ $maxLines }) => $maxLines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
